import Link from 'next/link';
import { Skeleton } from '../ui/skeleton';

// Skeleton component for lesson items
export default function ItemsListSkeleton({ length }: { length?: number }) {
  return Array.from({ length: length || 8 }).map((_, index) => (
    <li key={index} className="group relative w-full hover:bg-[var(--Surfaces-Extended-Amethyst-Transparent-Soft)] lg:px-6 py-3 bg-surface-1">
      <div className="align-center flex flex-row justify-between gap-4">
        <Link 
          href="#" 
          className="w-[80%] cursor-pointer"
          onClick={(e) => e.preventDefault()}
        >
          {/* Title skeleton */}
          <Skeleton className="bg-surface-3 mb-2 h-5 w-3/4" />
          {/* Meta info skeleton */}
          <div className="flex flex-row items-center gap-2">
            <Skeleton className="bg-surface-3 h-4 w-20" />
            <div>
              <span className="divider" />
            </div>
            <Skeleton className="bg-surface-3 h-4 w-16" />
          </div>
        </Link>
        {/* Icons skeleton */}
        <div className="flex flex-row items-center gap-1">
          <Skeleton className="bg-surface-3 h-6 w-6 rounded" />
        </div>
      </div>
    </li>
  ));
}
